import { notification } from "antd";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";

export class UserEditStore {
  loading = false;
  visible = false;
  saving = false;
  model?: any;

  constructor() {
    makeAutoObservable(this, {});
  }

  @action
  async edit(id) {
    this.loading = true;
    this.model = null;
    Api.user
      .user(id)
      .then((res) => {
        runInAction(() => {
          this.model = res.data.user;
          this.visible = true;
        });
      })
      .finally(() => (this.loading = false));
  }

  @action
  save(values) {
    this.saving = true;
    const { title, firstName, lastName } = values;
    return Api.user
      .save({ id: this.model.id, title, firstName, lastName })
      .then((res) => {
        this.visible = false;
        notification.success({ message: `User ${values.firstName} ${values.lastName} saved` });
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action
  close() {
    this.visible = false;
  }
}

export const userEditStore = new UserEditStore();
